// global.js 文件
export default {
  ws: {},
  setWs: function(newWs) {
    this.ws = newWs
  }
}



// WEBPACK FOOTER //
// ./src/utils/global.js